export default ( images ) => ( {
    img : images.img,
    imgDark : images.imgDark,
    imgMobile : images.imgMobile,
    imgMobileDark : images.imgMobileDark,
    isMobile : false,

    get isDarkMode() { 
        return Alpine.store( "commonStore" ).isDarkMode;
    },
    get bgImgStyle() {
        var light =  this.img != '' ? `background-image: url( ${this.img} );` : 'background-image: none;';
        var dark =  this.imgDark != '' ? `background-image: url( ${this.imgDark} );` : light;
        if( this.isMobile ) {
            light =  this.imgMobile != '' ? `background-image: url( ${this.imgMobile} );` : light;
            dark =  this.imgMobileDark != '' ? `background-image: url( ${this.imgMobileDark} );` : light;
        }
        return this.isDarkMode ? dark : light;
    },
    init(){
        var self = this;
        window.addEventListener( "resize", function(){ self.debounceMobileReset(self) } );
    },
    debounceMobileReset( c ) {
        // clear the timeout
        clearTimeout( c.timeout );
        // start timing for event "completion"
        c.timeout = setTimeout( function(){ c.setActiveImg( c ) }, 500 );
    },
    setActiveImg( c ) {
         if ( window.matchMedia("(max-width: 960px)").matches ) { // If media query matches
            if( !c.isMobile ) c.isMobile = true;
        } else {
            if( c.isMobile ) c.isMobile = false;
        }
    }    
} );